import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/#services', hasDropdown: true },
  { label: 'Process', to: '/#process' },
  { label: 'Our Work', to: '/#work' },
  { label: 'Blog', to: '/#blog' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/#contact' },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1 font-black text-2xl tracking-tight">
          <span className="text-[#E63946]">KAMIKATAZI</span>
          <span className="text-slate-900">CORP</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((n) => (
            <Link key={n.label} to={n.to} className="flex items-center gap-1 text-[15px] text-slate-800 hover:text-[#E63946] transition-colors font-medium">
              {n.label}
              {n.hasDropdown && <ChevronDown className="w-4 h-4" />}
            </Link>
          ))}
        </nav>
        <button className="lg:hidden text-slate-800" onClick={() => setOpen(!open)}>
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-100 bg-white">
          <div className="px-5 py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <Link key={n.label} to={n.to} onClick={() => setOpen(false)} className="text-slate-800 font-medium py-1">{n.label}</Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
